module.exports = __webpack_public_path__ + "media/images/country_flags/do-ff9abc92258e11e5ab9baa867476f051.png";